import { useEffect, useRef, useState } from 'react'
import { isAnyBlank } from '../../utils/string'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import TipoPruebaSelector from '../../components/form/TipoPruebaSelector/TipoPruebaSelector'
import css from './ModalNuevoTemario.module.css'

const ModalNuevoTemario = ({ open, onSubmit, onClose, isLoading }) => {
  const [temario, setTemario] = useState({
    nombre: '',
    asignaturas: [],
    tipo: ''
  })

  const [selectedFile, setSelectedFile] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setTemario({ nombre: '', asignaturas: [], tipo: '' })
      setSelectedFile(null)
    }
  }, [open])

  const isSubmitDisabled = isAnyBlank(temario.nombre) || !selectedFile

  const handleSubmit = () => {
    onSubmit({
      nombre: temario.nombre,
      archivo: selectedFile,
      asignaturas: temario.asignaturas,
      tipo: temario.tipo
    })
  }

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setSelectedFile(e.target.files[0])
    }
  }

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo temario</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Utiliza este formulario para crear un nuevo temario
        </DialogContentText>
        <TextField
          className={css.input}
          label='Nombre'
          value={temario.nombre}
          onChange={e => setTemario({ ...temario, nombre: e.target.value })}
          variant='standard'
        />
        <AsignaturaSelector
          multiple
          className={css.input}
          name='asignatura'
          label='Asignatura'
          value={temario.asignaturas}
          onChange={(_e, value) =>
            setTemario({ ...temario, asignaturas: value.map(a => a.id) || [] })
          }
        />
        <TipoPruebaSelector
          className={css.input}
          name='tipo'
          label='Tipo de Prueba'
          value={temario.tipo}
          onChange={e => setTemario({ ...temario, tipo: e.target.value })}
        />
        <div className={css.file}>
          <p>Adjuntar archivo PDF del temario</p>
          <Button size='small' type='secondary' onClick={handleUploadClick}>
            Seleccionar temario
          </Button>
          <input
            ref={inputRef}
            type='file'
            accept='application/pdf'
            name='pdf'
            onChange={handleFileChange}
            hidden
          />
          {selectedFile && (
            <span className={css.filename}>{selectedFile.name}</span>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoTemario
